var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content full" },
    [
      _c("e-breadcrumbs"),
      _c(
        "win-layer-pop",
        { staticClass: "sample_popup_list" },
        [
          _vm.customComponent
            ? _c(_vm.customComponent, {
                tag: "component",
                attrs: { "parent-info": _vm.parentInfo },
                on: { close: _vm.closePopup },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("h1", { staticClass: "page_title" }, [
        _vm._v(_vm._s(_vm.$t("cp.CTRL060P020.001"))),
      ]),
      _c("div", { staticClass: "content_box mt10" }, [
        _c("table", { staticClass: "tbl_search" }, [
          _vm._m(0),
          _c("tbody", [
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("cp.CTRL060P020.006")))]),
              _c("td", { staticClass: "cp-relative" }, [
                _c("input", {
                  staticClass: "cp-psel",
                  attrs: {
                    id: `yearWeekPsel`,
                    placeholder: _vm.setPselTxt("yearWeek"),
                    readonly: "",
                  },
                  on: {
                    mousedown: function ($event) {
                      $event.stopPropagation()
                      return _vm.clickPsel("yearWeek")
                    },
                  },
                }),
                _c(
                  "div",
                  {
                    staticClass: "cp-unitbox cp-popt cp-popt--close",
                    attrs: { id: `yearWeekPopt` },
                    on: {
                      mousedown: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "cp-li-header flex_box" }, [
                      _c("input", { attrs: { type: "checkbox", name: "no" } }),
                      _c(
                        "label",
                        {
                          class: {
                            "cp-pchkbox--disabled":
                              _vm.yearWeekList?.length === 0,
                            "cp-pchkbox--selected":
                              _vm.send.keyInput.yearWeek?.length !== 0 &&
                              _vm.yearWeekList.length ===
                                _vm.send.keyInput.yearWeek.length,
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.controlPchk("yearWeek")
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "offscreen" }, [
                            _vm._v("No"),
                          ]),
                        ]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.poptSearchKeyword,
                            expression: "poptSearchKeyword",
                          },
                        ],
                        attrs: {
                          id: `yearWeekPoptSearch`,
                          type: "text",
                          placeholder: _vm.$t("cp.COMMON.001"),
                          disabled: _vm.yearWeekList?.length === 0,
                        },
                        domProps: { value: _vm.poptSearchKeyword },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.poptSearchKeyword = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm.yearWeekList?.length !== 0
                      ? _c(
                          "ul",
                          {
                            staticClass:
                              "cp-scroll cp-ul cp-ul--plc cp-ul--hide",
                          },
                          [
                            _c("li", { staticClass: "cp-li" }, [
                              _c("input", {
                                attrs: { type: "checkbox", name: "no" },
                              }),
                              _vm._m(1),
                              _c("span", [
                                _vm._v(_vm._s(_vm.setLongestText("yearWeek"))),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "ul",
                      { staticClass: "cp-scroll cp-ul cp-ul--plc" },
                      _vm._l(_vm.yearWeekList, function (item, idx) {
                        return _c(
                          "li",
                          {
                            key: idx,
                            staticClass: "cp-li",
                            class: {
                              "cp-li--selected":
                                _vm.send.keyInput.yearWeek.includes(
                                  item.yearWeek
                                ),
                              "cp-li--hide": _vm.searchPopt(
                                "yearWeek",
                                item.yearWeek,
                                item.yearWeek
                              ),
                            },
                            attrs: { value: idx },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.clickPopt("yearWeek", item.yearWeek)
                              },
                            },
                          },
                          [
                            _c("input", {
                              attrs: { type: "checkbox", name: "no" },
                            }),
                            _c(
                              "label",
                              {
                                class: {
                                  "cp-pchkbox--selected":
                                    _vm.send.keyInput.yearWeek.includes(
                                      item.yearWeek
                                    ),
                                },
                              },
                              [
                                _c("span", { staticClass: "offscreen" }, [
                                  _vm._v("No"),
                                ]),
                              ]
                            ),
                            _c("span", [_vm._v(_vm._s(item.yearWeek))]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ]),
              _c("th", [_vm._v(_vm._s(_vm.$t("cp.CTRL060P020.037")))]),
              _c("td", { staticClass: "cp-relative" }, [
                _c("input", {
                  staticClass: "cp-psel",
                  attrs: {
                    id: `territoryPsel`,
                    placeholder: _vm.setPselTxt("territory"),
                    readonly: "",
                  },
                  on: {
                    mousedown: function ($event) {
                      $event.stopPropagation()
                      return _vm.clickPsel("territory")
                    },
                  },
                }),
                _c(
                  "div",
                  {
                    staticClass: "cp-unitbox cp-popt cp-popt--close",
                    attrs: { id: `territoryPopt` },
                    on: {
                      mousedown: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "cp-li-header flex_box" }, [
                      _c("input", { attrs: { type: "checkbox", name: "no" } }),
                      _c(
                        "label",
                        {
                          class: {
                            "cp-pchkbox--disabled":
                              _vm.territoryList?.length === 0,
                            "cp-pchkbox--selected":
                              _vm.send.keyInput.territory?.length !== 0 &&
                              _vm.territoryList.length ===
                                _vm.send.keyInput.territory.length,
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.controlPchk("territory")
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "offscreen" }, [
                            _vm._v("No"),
                          ]),
                        ]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.poptSearchKeyword,
                            expression: "poptSearchKeyword",
                          },
                        ],
                        attrs: {
                          id: `territoryPoptSearch`,
                          type: "text",
                          placeholder: _vm.$t("cp.COMMON.001"),
                          disabled: _vm.territoryList?.length === 0,
                        },
                        domProps: { value: _vm.poptSearchKeyword },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.poptSearchKeyword = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm.territoryList?.length !== 0
                      ? _c(
                          "ul",
                          {
                            staticClass:
                              "cp-scroll cp-ul cp-ul--plc cp-ul--hide",
                          },
                          [
                            _c("li", { staticClass: "cp-li" }, [
                              _c("input", {
                                attrs: { type: "checkbox", name: "no" },
                              }),
                              _vm._m(2),
                              _c("span", [
                                _vm._v(_vm._s(_vm.setLongestText("territory"))),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "ul",
                      { staticClass: "cp-scroll cp-ul cp-ul--plc" },
                      _vm._l(_vm.territoryList, function (item, idx) {
                        return _c(
                          "li",
                          {
                            key: idx,
                            staticClass: "cp-li",
                            class: {
                              "cp-li--selected":
                                _vm.send.keyInput.territory.includes(
                                  item.terCd
                                ),
                              "cp-li--hide": _vm.searchPopt(
                                "territory",
                                item.terCd,
                                item.terCd
                              ),
                            },
                            attrs: { value: idx },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.clickPopt("territory", item.terCd)
                              },
                            },
                          },
                          [
                            _c("input", {
                              attrs: { type: "checkbox", name: "no" },
                            }),
                            _c(
                              "label",
                              {
                                class: {
                                  "cp-pchkbox--selected":
                                    _vm.send.keyInput.territory.includes(
                                      item.terCd
                                    ),
                                },
                              },
                              [
                                _c("span", { staticClass: "offscreen" }, [
                                  _vm._v("No"),
                                ]),
                              ]
                            ),
                            _c("span", [_vm._v(_vm._s(item.terNm))]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ]),
              _c("th", [_vm._v(_vm._s(_vm.$t("cp.CTRL060P020.009")))]),
              _c("td", { staticClass: "cp-relative" }, [
                _c("input", {
                  staticClass: "cp-psel",
                  attrs: {
                    id: `routePsel`,
                    placeholder: _vm.setPselTxt("route"),
                    readonly: "",
                  },
                  on: {
                    mousedown: function ($event) {
                      $event.stopPropagation()
                      return _vm.clickPsel("route")
                    },
                  },
                }),
                _c(
                  "div",
                  {
                    staticClass: "cp-unitbox cp-popt cp-popt--close",
                    attrs: { id: `routePopt` },
                    on: {
                      mousedown: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "cp-li-header flex_box" }, [
                      _c("input", { attrs: { type: "checkbox", name: "no" } }),
                      _c(
                        "label",
                        {
                          class: {
                            "cp-pchkbox--disabled": _vm.routeList?.length === 0,
                            "cp-pchkbox--selected":
                              _vm.send.keyInput.route?.length !== 0 &&
                              _vm.routeList.length ===
                                _vm.send.keyInput.route.length,
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.controlPchk("route")
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "offscreen" }, [
                            _vm._v("No"),
                          ]),
                        ]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.poptSearchKeyword,
                            expression: "poptSearchKeyword",
                          },
                        ],
                        attrs: {
                          id: `routePoptSearch`,
                          type: "text",
                          placeholder: _vm.$t("cp.COMMON.001"),
                          disabled: _vm.routeList?.length === 0,
                        },
                        domProps: { value: _vm.poptSearchKeyword },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.poptSearchKeyword = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm.routeList?.length !== 0
                      ? _c(
                          "ul",
                          {
                            staticClass:
                              "cp-scroll cp-ul cp-ul--plc cp-ul--hide",
                          },
                          [
                            _c("li", { staticClass: "cp-li" }, [
                              _c("input", {
                                attrs: { type: "checkbox", name: "no" },
                              }),
                              _vm._m(3),
                              _c("span", [
                                _vm._v(_vm._s(_vm.setLongestText("route"))),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "ul",
                      { staticClass: "cp-scroll cp-ul cp-ul--plc" },
                      _vm._l(_vm.routeList, function (item, idx) {
                        return _c(
                          "li",
                          {
                            key: idx,
                            staticClass: "cp-li",
                            class: {
                              "cp-li--selected":
                                _vm.send.keyInput.route.includes(item.rteCd),
                              "cp-li--hide": _vm.searchPopt(
                                "route",
                                item.rteCd,
                                item.rteCd
                              ),
                            },
                            attrs: { value: idx },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.clickPopt("route", item.rteCd)
                              },
                            },
                          },
                          [
                            _c("input", {
                              attrs: { type: "checkbox", name: "no" },
                            }),
                            _c(
                              "label",
                              {
                                class: {
                                  "cp-pchkbox--selected":
                                    _vm.send.keyInput.route.includes(
                                      item.rteCd
                                    ),
                                },
                              },
                              [
                                _c("span", { staticClass: "offscreen" }, [
                                  _vm._v("No"),
                                ]),
                              ]
                            ),
                            _c("span", [_vm._v(_vm._s(item.rteCd))]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ]),
              _c("th", [_vm._v(_vm._s(_vm.$t("cp.CTRL060P020.043")))]),
              _c("td", { staticClass: "cp-relative" }, [
                _c("input", {
                  staticClass: "cp-psel",
                  attrs: {
                    id: `salesPsel`,
                    placeholder: _vm.setPselTxt("sales"),
                    readonly: "",
                  },
                  on: {
                    mousedown: function ($event) {
                      $event.stopPropagation()
                      return _vm.clickPsel("sales")
                    },
                  },
                }),
                _c(
                  "div",
                  {
                    staticClass: "cp-unitbox cp-popt cp-popt--close",
                    attrs: { id: `salesPopt` },
                    on: {
                      mousedown: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "cp-li-header flex_box" }, [
                      _c("input", { attrs: { type: "checkbox", name: "no" } }),
                      _c(
                        "label",
                        {
                          class: {
                            "cp-pchkbox--disabled": _vm.salesList?.length === 0,
                            "cp-pchkbox--selected":
                              _vm.send.keyInput.sales?.length !== 0 &&
                              _vm.salesList.length ===
                                _vm.send.keyInput.sales.length,
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.controlPchk("sales")
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "offscreen" }, [
                            _vm._v("No"),
                          ]),
                        ]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.poptSearchKeyword,
                            expression: "poptSearchKeyword",
                          },
                        ],
                        attrs: {
                          id: `salesPoptSearch`,
                          type: "text",
                          placeholder: _vm.$t("cp.COMMON.001"),
                          disabled: _vm.salesList?.length === 0,
                        },
                        domProps: { value: _vm.poptSearchKeyword },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.poptSearchKeyword = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm.salesList?.length !== 0
                      ? _c(
                          "ul",
                          {
                            staticClass:
                              "cp-scroll cp-ul cp-ul--plc cp-ul--hide",
                          },
                          [
                            _c("li", { staticClass: "cp-li" }, [
                              _c("input", {
                                attrs: { type: "checkbox", name: "no" },
                              }),
                              _vm._m(4),
                              _c("span", [
                                _vm._v(_vm._s(_vm.setLongestText("sales"))),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "ul",
                      { staticClass: "cp-scroll cp-ul cp-ul--plc" },
                      _vm._l(_vm.salesList, function (item, idx) {
                        return _c(
                          "li",
                          {
                            key: idx,
                            staticClass: "cp-li",
                            class: {
                              "cp-li--selected":
                                _vm.send.keyInput.sales.includes(item.salUno),
                              "cp-li--hide": _vm.searchPopt(
                                "sales",
                                item.salUno,
                                item.salUno
                              ),
                            },
                            attrs: { value: idx },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.clickPopt("sales", item.salUno)
                              },
                            },
                          },
                          [
                            _c("input", {
                              attrs: { type: "checkbox", name: "no" },
                            }),
                            _c(
                              "label",
                              {
                                class: {
                                  "cp-pchkbox--selected":
                                    _vm.send.keyInput.sales.includes(
                                      item.salUno
                                    ),
                                },
                              },
                              [
                                _c("span", { staticClass: "offscreen" }, [
                                  _vm._v("No"),
                                ]),
                              ]
                            ),
                            _c("span", [_vm._v(_vm._s(item.salUno))]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ]),
              _c("td", { staticClass: "text_right" }, [
                _c(
                  "a",
                  {
                    staticClass: "button blue sh",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.select.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("cp.COMMON.001")))]
                ),
              ]),
            ]),
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("cp.CTRL060P020.027")))]),
              _c("td", [
                _c("div", { staticClass: "tbl_form" }, [
                  _c("span", { staticClass: "dv" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.param.porCtr,
                            expression: "param.porCtr",
                          },
                        ],
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.param,
                                "porCtr",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                            function ($event) {
                              return _vm.getHarborList(_vm.param.porCtr)
                            },
                          ],
                        },
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(_vm._s(_vm.$t("cp.COMMON.002"))),
                        ]),
                        _vm._l(_vm.countryList, function (item, idx) {
                          return _c(
                            "option",
                            { key: idx, domProps: { value: item.ctrCd } },
                            [_vm._v(_vm._s(item.ctrEnm))]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                  _c("span", { staticClass: "dv" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.param.porPlc,
                            expression: "param.porPlc",
                          },
                        ],
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.param,
                              "porPlc",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(_vm._s(_vm.$t("cp.COMMON.002"))),
                        ]),
                        _vm._l(_vm.harborList, function (item, idx) {
                          return _c(
                            "option",
                            { key: idx, domProps: { value: item.plcCd } },
                            [_vm._v(_vm._s(item.plcNm))]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
              _c("th", [_vm._v(_vm._s(_vm.$t("cp.CTRL060P020.007")))]),
              _c("td", [
                _c("div", { staticClass: "tbl_form" }, [
                  _c("span", { staticClass: "dv" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.param.polCtr,
                            expression: "param.polCtr",
                          },
                        ],
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.param,
                                "polCtr",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                            function ($event) {
                              return _vm.getHarborList2(_vm.param.polCtr)
                            },
                          ],
                        },
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(_vm._s(_vm.$t("cp.COMMON.002"))),
                        ]),
                        _vm._l(_vm.countryList, function (item, idx) {
                          return _c(
                            "option",
                            { key: idx, domProps: { value: item.ctrCd } },
                            [_vm._v(_vm._s(item.ctrEnm))]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                  _c("span", { staticClass: "dv" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.param.polPlc,
                            expression: "param.polPlc",
                          },
                        ],
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.param,
                              "polPlc",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(_vm._s(_vm.$t("cp.COMMON.002"))),
                        ]),
                        _vm._l(_vm.harborList2, function (item, idx) {
                          return _c(
                            "option",
                            { key: idx, domProps: { value: item.plcCd } },
                            [_vm._v(_vm._s(item.plcNm))]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
              _c("th", { staticStyle: { width: "100px" } }, [
                _vm._v(_vm._s(_vm.$t("cp.CTRL060P020.008"))),
              ]),
              _c("td", [
                _c("div", { staticClass: "tbl_form" }, [
                  _c("span", { staticClass: "dv" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.param.podCtr,
                            expression: "param.podCtr",
                          },
                        ],
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.param,
                                "podCtr",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                            function ($event) {
                              return _vm.getHarborList3(_vm.param.podCtr)
                            },
                          ],
                        },
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(_vm._s(_vm.$t("cp.COMMON.002"))),
                        ]),
                        _vm._l(_vm.countryList, function (item, idx) {
                          return _c(
                            "option",
                            { key: idx, domProps: { value: item.ctrCd } },
                            [_vm._v(_vm._s(item.ctrEnm))]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                  _c("span", { staticClass: "dv" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.param.podPlc,
                            expression: "param.podPlc",
                          },
                        ],
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.param,
                              "podPlc",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(_vm._s(_vm.$t("cp.COMMON.002"))),
                        ]),
                        _vm._l(_vm.harborList3, function (item, idx) {
                          return _c(
                            "option",
                            { key: idx, domProps: { value: item.plcCd } },
                            [_vm._v(_vm._s(item.plcNm))]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
              _c("th", { staticStyle: { width: "100px" } }, [
                _vm._v(_vm._s(_vm.$t("cp.CTRL060P020.028"))),
              ]),
              _c("td", [
                _c("div", { staticClass: "tbl_form" }, [
                  _c("span", { staticClass: "dv" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.param.dlyCtr,
                            expression: "param.dlyCtr",
                          },
                        ],
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.param,
                                "dlyCtr",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                            function ($event) {
                              return _vm.getHarborList4(_vm.param.dlyCtr)
                            },
                          ],
                        },
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(_vm._s(_vm.$t("cp.COMMON.002"))),
                        ]),
                        _vm._l(_vm.countryList, function (item, idx) {
                          return _c(
                            "option",
                            { key: idx, domProps: { value: item.ctrCd } },
                            [_vm._v(_vm._s(item.ctrEnm))]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                  _c("span", { staticClass: "dv" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.param.dlyPlc,
                            expression: "param.dlyPlc",
                          },
                        ],
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.param,
                              "dlyPlc",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(_vm._s(_vm.$t("cp.COMMON.002"))),
                        ]),
                        _vm._l(_vm.harborList4, function (item, idx) {
                          return _c(
                            "option",
                            { key: idx, domProps: { value: item.plcCd } },
                            [_vm._v(_vm._s(item.plcNm))]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "tab" }, [
        _c("ul", [
          _c(
            "li",
            {
              staticClass: "on",
              attrs: { id: "tab1" },
              on: {
                click: function ($event) {
                  return _vm.selectTab(1)
                },
              },
            },
            [
              _c("a", { attrs: { href: "javascript:void(0)" } }, [
                _vm._v(_vm._s(_vm.$t("cp.CTRL060P010.073"))),
              ]),
            ]
          ),
          _c(
            "li",
            {
              attrs: { id: "tab2" },
              on: {
                click: function ($event) {
                  return _vm.selectTab(2)
                },
              },
            },
            [
              _c("a", { attrs: { href: "javascript:void(0)" } }, [
                _vm._v(_vm._s(_vm.$t("cp.CTRL060P010.074"))),
              ]),
            ]
          ),
        ]),
      ]),
      _c("div", { staticClass: "content_box" }, [
        _c("table", { staticClass: "tbl" }, [
          _c("tbody", [
            _c("tr", [
              _c("td", [
                _c(
                  "div",
                  {
                    staticClass: "flex_box",
                    staticStyle: { "margin-bottom": "-7px" },
                  },
                  [
                    _c(
                      "h2",
                      {
                        staticClass: "content_title",
                        staticStyle: {
                          "margin-top": "10px",
                          "margin-right": "auto",
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("cp.CTRL060P020.002")))]
                    ),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.param.solverGbCd,
                          expression: "param.solverGbCd",
                        },
                      ],
                      attrs: { type: "radio", id: "solverGbCd_1", value: "1" },
                      domProps: { checked: _vm._q(_vm.param.solverGbCd, "1") },
                      on: {
                        click: function ($event) {
                          return _vm.select(1)
                        },
                        change: function ($event) {
                          return _vm.$set(_vm.param, "solverGbCd", "1")
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "solverGbCd_1" } }, [
                      _vm._v("ALL"),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.param.solverGbCd,
                          expression: "param.solverGbCd",
                        },
                      ],
                      attrs: { type: "radio", id: "solverGbCd_2", value: "2" },
                      domProps: { checked: _vm._q(_vm.param.solverGbCd, "2") },
                      on: {
                        click: function ($event) {
                          return _vm.select(2)
                        },
                        change: function ($event) {
                          return _vm.$set(_vm.param, "solverGbCd", "2")
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "solverGbCd_2" } }, [
                      _vm._v("Success"),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.param.solverGbCd,
                          expression: "param.solverGbCd",
                        },
                      ],
                      attrs: { type: "radio", id: "solverGbCd_3", value: "3" },
                      domProps: { checked: _vm._q(_vm.param.solverGbCd, "3") },
                      on: {
                        click: function ($event) {
                          return _vm.select(3)
                        },
                        change: function ($event) {
                          return _vm.$set(_vm.param, "solverGbCd", "3")
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "solverGbCd_3" } }, [
                      _vm._v("Fail"),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.param.solverGbCd,
                          expression: "param.solverGbCd",
                        },
                      ],
                      attrs: { type: "radio", id: "solverGbCd_4", value: "4" },
                      domProps: { checked: _vm._q(_vm.param.solverGbCd, "4") },
                      on: {
                        click: function ($event) {
                          return _vm.select(4)
                        },
                        change: function ($event) {
                          return _vm.$set(_vm.param, "solverGbCd", "4")
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "solverGbCd_4" } }, [
                      _vm._v("Wait"),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "content_box mt13" }, [
                  _c("table", { staticClass: "tbl_col" }, [
                    _vm._m(5),
                    _c("thead", [
                      _c("tr", [
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("cp.CTRL060P020.009"))),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("cp.CTRL060P020.039"))),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("cp.CTRL060P020.027"))),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("cp.CTRL060P020.040"))),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("cp.CTRL060P020.007"))),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("cp.CTRL060P020.041"))),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("cp.CTRL060P020.008"))),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("cp.CTRL060P020.042"))),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("cp.CTRL060P020.028"))),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("cp.CTRL060P020.010"))),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("cp.CTRL060P020.011"))),
                        ]),
                      ]),
                    ]),
                    _c("tbody", [
                      _c("tr", [
                        _c("td", { staticClass: "chk" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.param.routeYn,
                                expression: "param.routeYn",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              name: "no",
                              id: "chk1",
                              "true-value": "Y",
                              "false-value": "",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.param.routeYn)
                                ? _vm._i(_vm.param.routeYn, null) > -1
                                : _vm._q(_vm.param.routeYn, "Y"),
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.param.routeYn,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? "Y" : ""
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.param,
                                        "routeYn",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.param,
                                        "routeYn",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.param, "routeYn", $$c)
                                }
                              },
                            },
                          }),
                          _vm._m(6),
                        ]),
                        _c("td", { staticClass: "chk" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.param.porCtrYn,
                                expression: "param.porCtrYn",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              name: "no",
                              id: "chk2",
                              "true-value": "Y",
                              "false-value": "",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.param.porCtrYn)
                                ? _vm._i(_vm.param.porCtrYn, null) > -1
                                : _vm._q(_vm.param.porCtrYn, "Y"),
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.param.porCtrYn,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? "Y" : ""
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.param,
                                        "porCtrYn",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.param,
                                        "porCtrYn",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.param, "porCtrYn", $$c)
                                }
                              },
                            },
                          }),
                          _vm._m(7),
                        ]),
                        _c("td", { staticClass: "chk" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.param.porPlcCdYn,
                                expression: "param.porPlcCdYn",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              name: "no",
                              id: "chk3",
                              "true-value": "Y",
                              "false-value": "",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.param.porPlcCdYn)
                                ? _vm._i(_vm.param.porPlcCdYn, null) > -1
                                : _vm._q(_vm.param.porPlcCdYn, "Y"),
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.param.porPlcCdYn,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? "Y" : ""
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.param,
                                        "porPlcCdYn",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.param,
                                        "porPlcCdYn",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.param, "porPlcCdYn", $$c)
                                }
                              },
                            },
                          }),
                          _vm._m(8),
                        ]),
                        _c("td", { staticClass: "chk" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.param.polCtrYn,
                                expression: "param.polCtrYn",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              name: "no",
                              id: "chk4",
                              "true-value": "Y",
                              "false-value": "",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.param.polCtrYn)
                                ? _vm._i(_vm.param.polCtrYn, null) > -1
                                : _vm._q(_vm.param.polCtrYn, "Y"),
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.param.polCtrYn,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? "Y" : ""
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.param,
                                        "polCtrYn",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.param,
                                        "polCtrYn",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.param, "polCtrYn", $$c)
                                }
                              },
                            },
                          }),
                          _vm._m(9),
                        ]),
                        _c("td", { staticClass: "chk" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.param.polPlcCdYn,
                                expression: "param.polPlcCdYn",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              name: "no",
                              id: "chk5",
                              "true-value": "Y",
                              "false-value": "",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.param.polPlcCdYn)
                                ? _vm._i(_vm.param.polPlcCdYn, null) > -1
                                : _vm._q(_vm.param.polPlcCdYn, "Y"),
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.param.polPlcCdYn,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? "Y" : ""
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.param,
                                        "polPlcCdYn",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.param,
                                        "polPlcCdYn",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.param, "polPlcCdYn", $$c)
                                }
                              },
                            },
                          }),
                          _vm._m(10),
                        ]),
                        _c("td", { staticClass: "chk" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.param.podCtrYn,
                                expression: "param.podCtrYn",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              name: "no",
                              id: "chk6",
                              "true-value": "Y",
                              "false-value": "",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.param.podCtrYn)
                                ? _vm._i(_vm.param.podCtrYn, null) > -1
                                : _vm._q(_vm.param.podCtrYn, "Y"),
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.param.podCtrYn,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? "Y" : ""
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.param,
                                        "podCtrYn",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.param,
                                        "podCtrYn",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.param, "podCtrYn", $$c)
                                }
                              },
                            },
                          }),
                          _vm._m(11),
                        ]),
                        _c("td", { staticClass: "chk" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.param.podPlcCdYn,
                                expression: "param.podPlcCdYn",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              name: "no",
                              id: "chk7",
                              "true-value": "Y",
                              "false-value": "",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.param.podPlcCdYn)
                                ? _vm._i(_vm.param.podPlcCdYn, null) > -1
                                : _vm._q(_vm.param.podPlcCdYn, "Y"),
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.param.podPlcCdYn,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? "Y" : ""
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.param,
                                        "podPlcCdYn",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.param,
                                        "podPlcCdYn",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.param, "podPlcCdYn", $$c)
                                }
                              },
                            },
                          }),
                          _vm._m(12),
                        ]),
                        _c("td", { staticClass: "chk" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.param.dlyCtrYn,
                                expression: "param.dlyCtrYn",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              name: "no",
                              id: "chk8",
                              "true-value": "Y",
                              "false-value": "",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.param.dlyCtrYn)
                                ? _vm._i(_vm.param.dlyCtrYn, null) > -1
                                : _vm._q(_vm.param.dlyCtrYn, "Y"),
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.param.dlyCtrYn,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? "Y" : ""
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.param,
                                        "dlyCtrYn",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.param,
                                        "dlyCtrYn",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.param, "dlyCtrYn", $$c)
                                }
                              },
                            },
                          }),
                          _vm._m(13),
                        ]),
                        _c("td", { staticClass: "chk" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.param.dlyPlcCdYn,
                                expression: "param.dlyPlcCdYn",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              name: "no",
                              id: "chk9",
                              "true-value": "Y",
                              "false-value": "",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.param.dlyPlcCdYn)
                                ? _vm._i(_vm.param.dlyPlcCdYn, null) > -1
                                : _vm._q(_vm.param.dlyPlcCdYn, "Y"),
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.param.dlyPlcCdYn,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? "Y" : ""
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.param,
                                        "dlyPlcCdYn",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.param,
                                        "dlyPlcCdYn",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.param, "dlyPlcCdYn", $$c)
                                }
                              },
                            },
                          }),
                          _vm._m(14),
                        ]),
                        _c("td", { staticClass: "chk" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.param.vslCdYn,
                                expression: "param.vslCdYn",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              name: "no",
                              id: "chk10",
                              "true-value": "Y",
                              "false-value": "",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.param.vslCdYn)
                                ? _vm._i(_vm.param.vslCdYn, null) > -1
                                : _vm._q(_vm.param.vslCdYn, "Y"),
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.param.vslCdYn,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? "Y" : ""
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.param,
                                        "vslCdYn",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.param,
                                        "vslCdYn",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.param, "vslCdYn", $$c)
                                }
                              },
                            },
                          }),
                          _vm._m(15),
                        ]),
                        _c("td", { staticClass: "chk" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.param.voyNoYn,
                                expression: "param.voyNoYn",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              name: "no",
                              id: "chk11",
                              "true-value": "Y",
                              "false-value": "",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.param.voyNoYn)
                                ? _vm._i(_vm.param.voyNoYn, null) > -1
                                : _vm._q(_vm.param.voyNoYn, "Y"),
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.param.voyNoYn,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? "Y" : ""
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.param,
                                        "voyNoYn",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.param,
                                        "voyNoYn",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.param, "voyNoYn", $$c)
                                }
                              },
                            },
                          }),
                          _vm._m(16),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.tapState === 1,
                        expression: "tapState === 1",
                      },
                    ],
                    staticClass: "mt5",
                    staticStyle: { width: "100%", height: "467px" },
                    attrs: { id: "realgrid1" },
                  }),
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.tapState === 2,
                        expression: "tapState === 2",
                      },
                    ],
                    staticClass: "mt5",
                    staticStyle: { width: "100%", height: "467px" },
                    attrs: { id: "realgrid6" },
                  }),
                ]),
              ]),
              _c("td", { attrs: { rowspan: "2" } }, [
                _c(
                  "div",
                  {
                    staticClass: "flex_box",
                    staticStyle: { "margin-bottom": "-7px" },
                  },
                  [
                    _c(
                      "h2",
                      {
                        staticClass: "content_title",
                        staticStyle: { "margin-top": "9px" },
                      },
                      [_vm._v(_vm._s(_vm.$t("cp.CTRL060P020.003")))]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "ml_auto cal_btn",
                        staticStyle: { "margin-top": "10px" },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "button sm",
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.add()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("cp.COMMON.009")))]
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "button sm ml2",
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.del()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("cp.COMMON.010")))]
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "button blue sm ml2",
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                _vm.asyncAlert(_vm.$t("cp.CTRL060P020.052"))
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("cp.COMMON.004")))]
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._m(17),
                _c(
                  "div",
                  {
                    staticClass: "flex_box",
                    staticStyle: { "margin-bottom": "-7px" },
                  },
                  [
                    _c(
                      "h2",
                      {
                        staticClass: "content_title",
                        staticStyle: { "margin-top": "9px" },
                      },
                      [_vm._v(_vm._s(_vm.$t("cp.CTRL060P020.004")))]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "ml_auto cal_btn",
                        staticStyle: { "margin-top": "10px" },
                      },
                      [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.bsaUser === "Z",
                                expression: "bsaUser === 'Z'",
                              },
                            ],
                            staticClass: "button blue sm ml2",
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                _vm.asyncAlert3(_vm.$t("cp.CTRL060P020.055"))
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("cp.CTRL060P020.054")))]
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "button blue sm ml2",
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                _vm.asyncAlert2(_vm.$t("cp.CTRL060P020.052"))
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("cp.COMMON.004")))]
                        ),
                      ]
                    ),
                  ]
                ),
                _c("div", { staticClass: "content_box mt10" }, [
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.tapState === 1,
                        expression: "tapState === 1",
                      },
                    ],
                    staticClass: "mt5",
                    staticStyle: { width: "100%", height: "774px" },
                    attrs: { id: "realgrid3" },
                  }),
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.tapState === 2,
                        expression: "tapState === 2",
                      },
                    ],
                    staticClass: "mt5",
                    staticStyle: { width: "100%", height: "774px" },
                    attrs: { id: "realgrid7" },
                  }),
                ]),
              ]),
            ]),
            _c("tr", [
              _c("td", [
                _c(
                  "div",
                  {
                    staticClass: "flex_box",
                    staticStyle: { "margin-bottom": "-7px" },
                  },
                  [
                    _c(
                      "h2",
                      {
                        staticClass: "content_title",
                        staticStyle: { "margin-top": "10px" },
                      },
                      [_vm._v(_vm._s(_vm.$t("cp.CTRL060P020.005")))]
                    ),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.gridGbCd,
                          expression: "gridGbCd",
                        },
                      ],
                      attrs: { type: "radio", id: "gridGbCd_1", value: "1" },
                      domProps: { checked: _vm._q(_vm.gridGbCd, "1") },
                      on: {
                        change: function ($event) {
                          _vm.gridGbCd = "1"
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "gridGbCd_1" } }, [
                      _vm._v("PROSPECT"),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.gridGbCd,
                          expression: "gridGbCd",
                        },
                      ],
                      attrs: { type: "radio", id: "gridGbCd_2", value: "2" },
                      domProps: { checked: _vm._q(_vm.gridGbCd, "2") },
                      on: {
                        change: function ($event) {
                          _vm.gridGbCd = "2"
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "gridGbCd_2" } }, [
                      _vm._v("BSA"),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "ml_auto cal_btn",
                        staticStyle: { "margin-top": "10px" },
                      },
                      [
                        _vm._v(" 기본 최저 유지 비율 "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.param.solverPercent,
                              expression: "param.solverPercent",
                            },
                          ],
                          staticStyle: { width: "38px" },
                          attrs: {
                            type: "text",
                            oninput:
                              "this.value = this.value.replace(/[^0-9.]/g, '')",
                            maxlength: "2",
                          },
                          domProps: { value: _vm.param.solverPercent },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.param,
                                "solverPercent",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" % "),
                        _c(
                          "a",
                          {
                            staticClass: "button blue sm ml2",
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.solver.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("cp.CTRL060P020.053")))]
                        ),
                      ]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.gridGbCd === "1",
                        expression: "gridGbCd === '1'",
                      },
                    ],
                    staticClass: "content_box mt10",
                  },
                  [
                    _c(
                      "h5",
                      {
                        staticClass: "content_title",
                        staticStyle: { display: "inline" },
                      },
                      [_vm._v(_vm._s(_vm.vslVoyInfo))]
                    ),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tapState === 1,
                          expression: "tapState === 1",
                        },
                      ],
                      staticClass: "mt5",
                      staticStyle: { width: "100%", height: "330px" },
                      attrs: { id: "realgrid4" },
                    }),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tapState === 2,
                          expression: "tapState === 2",
                        },
                      ],
                      staticClass: "mt5",
                      staticStyle: { width: "100%", height: "330px" },
                      attrs: { id: "realgrid8" },
                    }),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.gridGbCd === "2",
                        expression: "gridGbCd === '2'",
                      },
                    ],
                    staticClass: "content_box mt10",
                  },
                  [
                    _c(
                      "h5",
                      {
                        staticClass: "content_title",
                        staticStyle: { display: "inline" },
                      },
                      [_vm._v(_vm._s(_vm.vslVoyInfo))]
                    ),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tapState === 1,
                          expression: "tapState === 1",
                        },
                      ],
                      staticClass: "mt5",
                      staticStyle: { width: "100%", height: "330px" },
                      attrs: { id: "realgrid5" },
                    }),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tapState === 2,
                          expression: "tapState === 2",
                        },
                      ],
                      staticClass: "mt5",
                      staticStyle: { width: "100%", height: "330px" },
                      attrs: { id: "realgrid9" },
                    }),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "100px" } }),
      _c("col"),
      _c("col", { attrs: { width: "90px" } }),
      _c("col"),
      _c("col", { attrs: { width: "100px" } }),
      _c("col"),
      _c("col", { attrs: { width: "100px" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _c("span", { staticClass: "offscreen" }, [_vm._v("No")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _c("span", { staticClass: "offscreen" }, [_vm._v("No")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _c("span", { staticClass: "offscreen" }, [_vm._v("No")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _c("span", { staticClass: "offscreen" }, [_vm._v("No")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "7.69%" } }),
      _c("col", { attrs: { width: "7.69%" } }),
      _c("col", { attrs: { width: "7.69%" } }),
      _c("col", { attrs: { width: "7.69%" } }),
      _c("col", { attrs: { width: "7.69%" } }),
      _c("col", { attrs: { width: "7.69%" } }),
      _c("col", { attrs: { width: "7.69%" } }),
      _c("col", { attrs: { width: "7.69%" } }),
      _c("col", { attrs: { width: "7.69%" } }),
      _c("col", { attrs: { width: "7.69%" } }),
      _c("col", { attrs: { width: "7.69%" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "chk1" } }, [
      _c("span", { staticClass: "offscreen" }, [_vm._v("No")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "chk2" } }, [
      _c("span", { staticClass: "offscreen" }, [_vm._v("No")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "chk3" } }, [
      _c("span", { staticClass: "offscreen" }, [_vm._v("No")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "chk4" } }, [
      _c("span", { staticClass: "offscreen" }, [_vm._v("No")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "chk5" } }, [
      _c("span", { staticClass: "offscreen" }, [_vm._v("No")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "chk6" } }, [
      _c("span", { staticClass: "offscreen" }, [_vm._v("No")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "chk7" } }, [
      _c("span", { staticClass: "offscreen" }, [_vm._v("No")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "chk8" } }, [
      _c("span", { staticClass: "offscreen" }, [_vm._v("No")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "chk9" } }, [
      _c("span", { staticClass: "offscreen" }, [_vm._v("No")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "chk10" } }, [
      _c("span", { staticClass: "offscreen" }, [_vm._v("No")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "chk11" } }, [
      _c("span", { staticClass: "offscreen" }, [_vm._v("No")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content_box mt10" }, [
      _c("div", {
        staticClass: "mt5",
        staticStyle: { width: "100%", height: "118px" },
        attrs: { id: "realgrid2" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }